module.exports = "/assets/bees-online.png";